import { useEffect, useRef } from "react";

export const useSingleEffect = (cb: () => any) => {
    const usedRef = useRef(false);

    useEffect(() => {
        if (usedRef.current) return;
        usedRef.current = true;
        cb();
    }, []);
};